/* See theme.dev.js "showMobileClass"/L6767 for potential refactor */

(function() {
  // Helpers
  function getIsMobile() {
    const mobileRegex = /Mobi|Android|iPhone|iPad|iPod/i
    const isMobileDevice = mobileRegex.test(navigator.userAgent);
    if (isMobileDevice) return true;

    const isMobileHeader = document.querySelector('.header__wrapper--custom.js__show__mobile');
    if (isMobileHeader) return true;

    const mobileWidth = 479; // Classname .js__show__mobile doesn't get added on devices smaller than this
    const isMobileWidth = window.innerWidth <= mobileWidth;
    if (isMobileWidth) return true;

    return false;
  }

  function getElementHeight(query) {
    const element = document.querySelector(query);
    return element.offsetHeight || 0;
  }

  function getHeaderHeight() { 
    const isHeaderStuck = document.querySelector('.header__wrapper--custom.js__header__stuck');
    const themeHeaderHeight = getElementHeight('header.theme__header');
    const announcementBarHeight = getElementHeight('div.announcement[data-announcement-bar]');

    let headerHeight = 0;
    if (isHeaderStuck) {
      headerHeight = themeHeaderHeight;
    } else {
      headerHeight = themeHeaderHeight;
      if (announcementBarHeight > 0) {
        headerHeight += announcementBarHeight;
      }
    }

    const headerHeightFinal = headerHeight - 1; // To help with rounding errors
    return headerHeightFinal;
  }

  // Event Handlers
  function handleHeaderOnStick() {
    const isHeaderStuck = document.querySelector('.header__wrapper--custom.js__header__stuck');
    if (!isHeaderStuck) return;

    const header = document.querySelector('.header__wrapper--custom');
    const observer = new MutationObserver(function(mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          setMobileNavDrawerPosition();
        }
      }
    });

    observer.observe(header, { attributes: true });
  }

  function handleResize() {
    let resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        setMobileNavDrawerPosition();
        setBodyWithMobileClass();
        setThemeHeaderHeight();
      }, 200);
    });
  }

  function handleMobileMenuButton() {
    const isMobile = getIsMobile();
    if (!isMobile) return;

    const button = document.querySelector('button.header__mobile__button');
    button.addEventListener('click', function() {
      const isExpanded = button.getAttribute('aria-expanded');
      if (isExpanded) {
        button.setAttribute('aria-expanded', 'false');
      } else {
        button.setAttribute('aria-expanded', 'true');
      }
    });
  }

  // Implementations
  function setMobileNavDrawerPosition() {
    const isMobile = getIsMobile();
    if (!isMobile) return;

    const headerHeight = getHeaderHeight();
    if (headerHeight <= 0) return;

    const drawerInner = document.querySelector('.header__wrapper--custom nav.header__drawer .drawer__content');
    if (drawerInner) {
      drawerInner.style.top = `${headerHeight}px`;
      drawerInner.style.paddingBottom = `${headerHeight}px`;
    }

    const drawerUnderlay = document.querySelector('.header__wrapper--custom nav.header__drawer .drawer__underlay');
    if (drawerUnderlay) {
      drawerUnderlay.style.top = `${headerHeight}px`;
    }
  }

  function setBodyWithMobileClass() {
    const isMobile = getIsMobile();
    if (!isMobile) return;

    const body = document.querySelector('body');
    body.classList.add('is-mobile-device--custom')
  }

  function setThemeHeaderHeight() {
    const themeHeaderParent = document.querySelector('div[id$="__header"].shopify-section-group-group-header');
    const themeHeaderHeight = getElementHeight('header.theme__header');
    themeHeaderParent.style.height = `${themeHeaderHeight}px`;
  }

  // Setup
  function init() {
    document.addEventListener('DOMContentLoaded', function() {
      // Init
      setBodyWithMobileClass();

      // Delay to allow for header to get correctly set
      setTimeout(function() {
        setMobileNavDrawerPosition();
        setThemeHeaderHeight();
      }, 500)

      // Handle Changes
      handleHeaderOnStick();
      handleResize();
      handleMobileMenuButton();
    });
  }

  init();
})();